import { useCallback } from 'react';

import { useExperimentInfo } from '../../store/experimentInfoStore';

export const useCloseModalEvents = () => {
	const { stopEpMessage, stopModalFeatureDiscovery } = useExperimentInfo();

	const fireCloseModalEvents = useCallback(() => {
		if (stopEpMessage && stopModalFeatureDiscovery) {
			void stopEpMessage();
			void stopModalFeatureDiscovery();
		}
	}, [stopEpMessage, stopModalFeatureDiscovery]);

	return { fireCloseModalEvents };
};
